<template>
  <b-row>
    <b-col md="12">
      <div class="table-responsive">
        <h6 class="package-title" v-translate>Flight info</h6>
        <table class="table table-sm text-center">
          <thead class="t-head thead-light text-center">
            <tr>
              <td v-translate >Flight</td>
              <td v-translate >Flight no. </td>
              <td v-translate >Date</td>
              <td v-translate >Depart</td>
              <td v-translate >Hour</td>
              <td v-translate >Arrival</td>
              <td v-translate >Hour</td>
              <td v-translate >Durration</td>
            </tr>
          </thead>
          <tbody>
            <template v-for="(leg, legIndex) in info.outbound">
              <tr :key="legIndex + 'fout'">
                <td v-translate>Departure</td>
                <td>{{ leg.airline }} {{ leg.flight }}</td>
                <td>{{ leg.date }}</td>
                <td>{{ leg.from_name }}</td>
                <td>{{ leg.depTime == '00:00' ? 'n/a' : leg.depTime  }}</td>
                <td>{{ leg.to_name }}</td>
                <td>{{ leg.arrTime == '00:00' ? 'n/a' : leg.arrTime }}</td>
                <td>{{ leg.duration }}</td>
              </tr>
            </template>
            <template v-for="(leg, legIndex) in info.inbound">
              <tr :key="legIndex + 'fin'">
                <td v-translate>Return</td>
                <td>{{ leg.airline }} {{ leg.flight }}</td>
                <td>{{ leg.date }}</td>
                <td>{{ leg.from_name }}</td>
                <td>{{ leg.depTime == '00:00' ? 'n/a' : leg.depTime  }}</td>
                <td>{{ leg.to_name }}</td>
                <td>{{ leg.arrTime == '00:00' ? 'n/a' : leg.arrTime }}</td>
                <td>{{ leg.duration }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'FlightInfo',
  props: ['info']
}
</script>
